import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App.tsx';
import { theme } from './customTheme.tsx';
import { ThemeProvider } from '@mui/material';
import { Auth0ProviderWithNavigate } from './app/Auth0ProviderWithNavigate.tsx';
import { BrowserRouter } from 'react-router';
import { initSentry } from './utils/sentry.ts';
import { GraphQlProvider } from './app/GraphQlProvider.tsx';

initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Auth0ProviderWithNavigate>
          <GraphQlProvider>
            <App />
          </GraphQlProvider>
        </Auth0ProviderWithNavigate>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
